import Antd from 'ant-design-vue';
import alpButton from '../components/alp-components/alp-button/button.vue'
// antd-Icon
import * as AntdIcon from '@ant-design/icons-vue';
// alp-UA-Icon
import alpIcon from "../components/alp-components/icons/icon.vue";
// alp-formGroup
import alpFormGroup from "../components/alp-components/alp-form/form.vue";
// alp-cron
import alpCron from "../components/alp-components/alp-cron/cron.vue";
// alp-table
import STable from "alp-table";

//alp-table
import alpTable from "../components/alp-components/alp-table/table.vue";

//alp-modal
import alpModal from "../components/alp-components/alp-modal/index.vue";

//alp-selector
import alpSelector from "../components/alp-components/alp-selector/index.vue";

//alp-tree
import alpTree from "../components/alp-components/alp-tree/tree.vue";

//alp-multiText
import alpMultiText from "../components/alp-components/alp-multiText/multiText.vue";

const alpUI = {}
alpUI.install = function (Vue) {
	Vue.use(Antd);
	for (var k in AntdIcon) {
		Vue.component(k, AntdIcon[k])
	}

	// alp-table
	Vue.use(STable);

	Vue.component(alpButton.name, alpButton);
	// ua-icon
	Vue.component(alpIcon.name, alpIcon);
	// alp-formGroup
	Vue.component(alpFormGroup.name, alpFormGroup);
	// alp-cron
	Vue.component(alpCron.name, alpCron);

	//alp-table
	Vue.component(alpTable.name, alpTable);
	// alp-modal
	Vue.component(alpModal.name, alpModal);
	// alp-tree
	Vue.component(alpTree.name, alpTree);
	// alp-selector
	Vue.component(alpSelector.name, alpSelector);
	// alp-multiText
	Vue.component(alpMultiText.name, alpMultiText);
}

import "./style/index.css";

export default alpUI;
